import * as Yup from "yup";
import Strings from "../Config/Strings";

const productSchema = Yup.object().shape({
  productName: Yup.string().required(Strings.productNameError),
  // productCategory: Yup.string().required(Strings.categoryNameError),
  // productMetal: Yup.string().required(Strings.metalNameRequiredError),
  // metalPurity: Yup.string().required(Strings.purityRequiredError),
  // productDescription: Yup.string().required(Strings.descriptionRequiredError),
  // grossWeight: Yup.string().required(Strings.grossRequiredError),
  // lessWeight: Yup.string().required(Strings.lessRequiredError),
  // Quantity: Yup.number()
  //   .required(Strings.quantityRequiredError)
  //   .positive(Strings.quantityPositiveError)
  //   .integer(Strings.quantityIntegerError),
  // productPrice: Yup.number()
  //   .required(Strings.priceRequiredError)
  //   .positive(Strings.pricePositiveError),
  // productCode: Yup.string().required(Strings.productCodeRequiredError),
});

const userSchema = Yup.object().shape({
  firstName: Yup.string().required(Strings.firstNameRequired),
  lastName: Yup.string().required(Strings.lastNameRequired),
  userEmail: Yup.string().required(Strings.userEmailRequired),
  userMobileNo: Yup.string()
  .required(Strings.userMobileNoRequired)
  .matches(/^[0-9]+$/, Strings.phoneNumberNumericError)
  .length(10, Strings.phoneNumberLengthError),
  userAddress: Yup.string().required(Strings.userAddressRequired),
  panCardNo: Yup.string().required('Pan card can not be empty'),
  pinCode: Yup.string().required('Pin Code can not be empty'),
});


const phoneSchema = Yup.object().shape({
  mobileNo: Yup.string()
  .required(Strings.userMobileNoRequired)
  .matches(/^[0-9]+$/, Strings.phoneNumberNumericError)
  .length(10, Strings.phoneNumberLengthError), // Adjust length as needed
});

export { productSchema, userSchema, phoneSchema };
